import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage } from "@/pages/Auth";
import { Overview, BuyCoupon, MyCoupons, Referrals, Commissions, Withdrawals, KYCPage, Support, OrderStatus, BoomBox } from "@/pages/UserPages";
import {
  AdminOverview, AdminUsers, AdminOrders, AdminCommissions, AdminWithdrawals,
  AdminKyc, AdminTickets, AdminSettings, AdminAudit, ForceChangePassword,
  AdminBoomBox, AdminNotifications, AdminMLM,
} from "@/pages/AdminPages";

function Protected({ children, adminOnly = false }) {
  const { user, booting, refresh } = useAuth();
  if (booting) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  if (user.must_change_password) return <ForceChangePassword onDone={refresh} />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route path="/app" element={<Protected><Overview /></Protected>} />
          <Route path="/app/buy" element={<Protected><BuyCoupon /></Protected>} />
          <Route path="/app/order/:id" element={<Protected><OrderStatus /></Protected>} />
          <Route path="/app/coupons" element={<Protected><MyCoupons /></Protected>} />
          <Route path="/app/referrals" element={<Protected><Referrals /></Protected>} />
          <Route path="/app/commissions" element={<Protected><Commissions /></Protected>} />
          <Route path="/app/withdrawals" element={<Protected><Withdrawals /></Protected>} />
          <Route path="/app/kyc" element={<Protected><KYCPage /></Protected>} />
          <Route path="/app/boombox" element={<Protected><BoomBox /></Protected>} />
          <Route path="/app/support" element={<Protected><Support /></Protected>} />

          <Route path="/admin" element={<Protected adminOnly><AdminOverview /></Protected>} />
          <Route path="/admin/users" element={<Protected adminOnly><AdminUsers /></Protected>} />
          <Route path="/admin/mlm" element={<Protected adminOnly><AdminMLM /></Protected>} />
          <Route path="/admin/orders" element={<Protected adminOnly><AdminOrders /></Protected>} />
          <Route path="/admin/commissions" element={<Protected adminOnly><AdminCommissions /></Protected>} />
          <Route path="/admin/withdrawals" element={<Protected adminOnly><AdminWithdrawals /></Protected>} />
          <Route path="/admin/kyc" element={<Protected adminOnly><AdminKyc /></Protected>} />
          <Route path="/admin/tickets" element={<Protected adminOnly><AdminTickets /></Protected>} />
          <Route path="/admin/settings" element={<Protected adminOnly><AdminSettings /></Protected>} />
          <Route path="/admin/boombox" element={<Protected adminOnly><AdminBoomBox /></Protected>} />
          <Route path="/admin/notifications" element={<Protected adminOnly><AdminNotifications /></Protected>} />
          <Route path="/admin/audit" element={<Protected adminOnly><AdminAudit /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
